import React from 'react';

export const joinedDays = (leave) => (leave?.join_bridge || []).reduce((n, b) => n + (b.dates?.length || 0), 0);

export default function JoinedBadge({ leave }) {
  const n = joinedDays(leave);
  if (!n) return null;
  const dates = (leave.join_bridge || []).flatMap((b) => b.dates || []).join(', ');
  return (
    <span title={`Joined to another leave across ${dates} — these ${n} day(s) are also charged`} data-testid={`joined-badge-${leave._id || leave.id}`}
      className="inline-flex items-center text-[10px] font-semibold bg-orange-50 text-orange-700 px-2 py-0.5 rounded-full ml-1">
      +{n} joined
    </span>
  );
}
